<div class="h-full container mx-auto">
  <slot></slot>
</div>